import { SpeedDial, darken, styled } from '@mui/material';
import { Typography } from '@totalsoft/rocket-ui';

export const InsuranceHeaderTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: theme.typography.fontWeightBold,
  paddingRight: theme.spacing(2)
}));

export const InsuranceHeaderActionsWrapper = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    width: '100px',
    height: '50px'
  },
  position: 'relative',
  display: 'flex',
  flexWrap: 'nowrap',
  gap: theme.spacing(0.5)
}));

export const InsuranceHeaderActionsSpeedDial = styled(SpeedDial)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  '& .MuiSpeedDial-actions': {
    display: 'flex',
    gap: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(-4.5)
    }
  },
  '& .MuiSpeedDialAction-fab': {
    margin: 0,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: darken(theme.palette.secondary.main, 0.2)
    },
    '& > svg': {
      fontSize: '1.5rem'
    }
  }
}));
